<template>
  <div>
    <my-request-layout
      :workflowGuid="registration.workflowGuid"
      :foundRequest="!!registration"
      :isLoading="isLoading"
      :myRequest="registration"
      :cancelRequest="cancelRequest"
      :paymentStatus="paymentStatus"
      
      useAuthorizedPayment
      :makePayment="makePayment"
      :authorizePayment="authorizePayment"
      :showPaymentAuthorizationStatus="registration.needsPaymentAuthorization"
    >
      <span slot="title"
        >Create Affiliate: {{ registration.affiliateRequestData.affiliateName }}</span
      >

      <div slot="requestContent" v-if="registration.affiliateRequestData" class="mb-5">
        <create-affiliate-request :registration="registration.affiliateRequestData"></create-affiliate-request>
      </div>
    </my-request-layout>
    <v-snackbar v-model="showErrorMessage" title color="error">
      {{ errorMessage }}
      <template v-slot:action="{ attrs }">
      <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
        Close
      </v-btn>
      </template>
    </v-snackbar>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import MyRequestLayout from "@/components/Portal/MyRequest/MyRequestLayout.vue";
import CreateAffiliateRequest from "@/components/Portal/MyRequest/CreateAffiliateRequest.vue";

import workflowService from "@/services/portal/workflowService";

import { UserInfo } from "@/types/User";
import AuthorizeNetResponseData from "@/types/AuthorizeNetResponseData";

export default Vue.extend({
  name: "MyAffiliateRegistrationRequest",
  components: {
    MyRequestLayout,
    CreateAffiliateRequest,
  },
  data: function () {
    return {
      registration: Object as any,
      isLoading: false,
      paymentStatus: null,
      errorMessage: "",
      showErrorMessage: false,
    };
  },
  props: {
    workflowGuid: { type: String },
  },
  methods: {
    load() {
      this.isLoading = true;
      workflowService
        .getAffiliateRegistrationRequestDetails(this.workflowGuid)
        .then((res) => {
          this.isLoading = false;
          this.registration = res;
        });
    },
    authorizePayment: function (paymentInfo: AuthorizeNetResponseData) {
      var req = {
        paymentInfo,
        workflowGuid: this.registration.workflowGuid,
      };
      workflowService.submitAffiliateRegistrationCCAuthorization(req).then((res) => {
        this.paymentStatus = res;
        this.load();
      });
    },
    makePayment: function (paymentInfo: AuthorizeNetResponseData) {
      var req = {
        paymentInfo,
        workflowGuid: this.registration.workflowGuid,
      };
      workflowService.submitAffiliateRegistrationCCPayment(req).then(res => {
        if (res.error) {
          this.errorMessage = res.error;
          this.showErrorMessage = true;
        }
        else {
          this.paymentStatus = res;
        }

        this.load();
      });
    },
    cancelRequest: function () {
    },
  },
  created() {
    this.load();
  },
  watch: {
    workflowGuid: function (newValue) {
      this.load();
    },
  },
  computed: {
    userInfo(): UserInfo {
      return this.$store.state.userInfo;
    },
  },
});
</script>
